import { FastSimonReporting } from "./components/FastSimonReporting";
import { getFastSimonReporting } from "./utils/getFastSimonReporting";
import { Cart } from "./services/cart";
import { ReportingUpType } from "./services/reporting";
function getCartToken(platform) {
    return Cart.getToken(platform);
}
export { FastSimonReporting, getFastSimonReporting, getCartToken, ReportingUpType };
//# sourceMappingURL=main.js.map